module.exports = __webpack_public_path__ + "img/benefit3.68505ee1.png";